module.exports = __webpack_public_path__ + "img/pic_2.a54d1cc7.jpg";